/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ActiveReferralProgramResponse,
  ApiError,
  CreateReferralRewardThresholdBody,
  GenerateAllReferralsResponse,
  GetReferralCodesResponse,
  GetReferralRewardThresholdsResponse,
  GetReferralRewardThresholdsSort,
  ReferralLinkText,
  ReferralLinkTextBody,
  ReferralRewardThreshold,
  ReferredUsersResponse,
  RelationshipType,
  RemoveReferralRequestBody,
  SortOrder,
} from '../models/index';
import {
    ActiveReferralProgramResponseFromJSON,
    ActiveReferralProgramResponseToJSON,
    ApiErrorFromJSON,
    ApiErrorToJSON,
    CreateReferralRewardThresholdBodyFromJSON,
    CreateReferralRewardThresholdBodyToJSON,
    GenerateAllReferralsResponseFromJSON,
    GenerateAllReferralsResponseToJSON,
    GetReferralCodesResponseFromJSON,
    GetReferralCodesResponseToJSON,
    GetReferralRewardThresholdsResponseFromJSON,
    GetReferralRewardThresholdsResponseToJSON,
    GetReferralRewardThresholdsSortFromJSON,
    GetReferralRewardThresholdsSortToJSON,
    ReferralLinkTextFromJSON,
    ReferralLinkTextToJSON,
    ReferralLinkTextBodyFromJSON,
    ReferralLinkTextBodyToJSON,
    ReferralRewardThresholdFromJSON,
    ReferralRewardThresholdToJSON,
    ReferredUsersResponseFromJSON,
    ReferredUsersResponseToJSON,
    RelationshipTypeFromJSON,
    RelationshipTypeToJSON,
    RemoveReferralRequestBodyFromJSON,
    RemoveReferralRequestBodyToJSON,
    SortOrderFromJSON,
    SortOrderToJSON,
} from '../models/index';

export interface CreateReferralRewardThresholdRequest {
    createReferralRewardThresholdBody?: CreateReferralRewardThresholdBody;
}

export interface DeleteReferralsRemoveReferralRequest {
    removeReferralRequestBody?: RemoveReferralRequestBody;
}

export interface GetReferralLinkTextRequest {
    relationshipType?: RelationshipType;
    referralCode?: string;
}

export interface GetReferralRewardThresholdsRequest {
    disabled?: boolean;
    sort?: GetReferralRewardThresholdsSort;
    order?: SortOrder;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface GetReferralsRequest {
    userId?: string;
}

export interface GetReferralsGetReferredUsersIdRequest {
    id: string;
}

export interface UpdateReferralLinkTextRequest {
    referralLinkTextBody?: ReferralLinkTextBody;
}

export interface UpdateReferralRewardThresholdIdRequest {
    id: string;
    createReferralRewardThresholdBody?: CreateReferralRewardThresholdBody;
}

/**
 * ReferralsApi - interface
 * 
 * @export
 * @interface ReferralsApiInterface
 */
export interface ReferralsApiInterface {
    /**
     * Allows admins to create referral thresholds.
     * @param {CreateReferralRewardThresholdBody} [createReferralRewardThresholdBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralsApiInterface
     */
    createReferralRewardThresholdRaw(requestParameters: CreateReferralRewardThresholdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReferralRewardThreshold>>;

    /**
     * Allows admins to create referral thresholds.
     */
    createReferralRewardThreshold(requestParameters: CreateReferralRewardThresholdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReferralRewardThreshold>;

    /**
     * removes a referral for a given user
     * @param {RemoveReferralRequestBody} [removeReferralRequestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralsApiInterface
     */
    deleteReferralsRemoveReferralRaw(requestParameters: DeleteReferralsRemoveReferralRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * removes a referral for a given user
     */
    deleteReferralsRemoveReferral(requestParameters: DeleteReferralsRemoveReferralRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {RelationshipType} [relationshipType] 
     * @param {string} [referralCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralsApiInterface
     */
    getReferralLinkTextRaw(requestParameters: GetReferralLinkTextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReferralLinkText>>;

    /**
     */
    getReferralLinkText(requestParameters: GetReferralLinkTextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReferralLinkText>;

    /**
     * 
     * @param {boolean} [disabled] 
     * @param {GetReferralRewardThresholdsSort} [sort] 
     * @param {SortOrder} [order] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralsApiInterface
     */
    getReferralRewardThresholdsRaw(requestParameters: GetReferralRewardThresholdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetReferralRewardThresholdsResponse>>;

    /**
     */
    getReferralRewardThresholds(requestParameters: GetReferralRewardThresholdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetReferralRewardThresholdsResponse>;

    /**
     * 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralsApiInterface
     */
    getReferralsRaw(requestParameters: GetReferralsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetReferralCodesResponse>>;

    /**
     */
    getReferrals(requestParameters: GetReferralsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetReferralCodesResponse>;

    /**
     * Public read of the active referral program. Returns the highest-reward, non-disabled, non-hidden, non-expired ReferralRewardThreshold as a display payload for the /account Refer-a-Friend section. Admin owns every string surfaced here verbatim.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralsApiInterface
     */
    getReferralsActiveProgramRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ActiveReferralProgramResponse>>;

    /**
     * Public read of the active referral program. Returns the highest-reward, non-disabled, non-hidden, non-expired ReferralRewardThreshold as a display payload for the /account Refer-a-Friend section. Admin owns every string surfaced here verbatim.
     */
    getReferralsActiveProgram(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ActiveReferralProgramResponse>;

    /**
     * generate all referrals data for exporting CSV in the admin portal
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralsApiInterface
     */
    getReferralsGenerateAllReferralsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenerateAllReferralsResponse>>;

    /**
     * generate all referrals data for exporting CSV in the admin portal
     */
    getReferralsGenerateAllReferrals(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenerateAllReferralsResponse>;

    /**
     * Get a user\'s referred users
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralsApiInterface
     */
    getReferralsGetReferredUsersIdRaw(requestParameters: GetReferralsGetReferredUsersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReferredUsersResponse>>;

    /**
     * Get a user\'s referred users
     */
    getReferralsGetReferredUsersId(requestParameters: GetReferralsGetReferredUsersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReferredUsersResponse>;

    /**
     * 
     * @param {ReferralLinkTextBody} [referralLinkTextBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralsApiInterface
     */
    updateReferralLinkTextRaw(requestParameters: UpdateReferralLinkTextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    updateReferralLinkText(requestParameters: UpdateReferralLinkTextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Allows admins to update referral thresholds.
     * @param {string} id 
     * @param {CreateReferralRewardThresholdBody} [createReferralRewardThresholdBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralsApiInterface
     */
    updateReferralRewardThresholdIdRaw(requestParameters: UpdateReferralRewardThresholdIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReferralRewardThreshold>>;

    /**
     * Allows admins to update referral thresholds.
     */
    updateReferralRewardThresholdId(requestParameters: UpdateReferralRewardThresholdIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReferralRewardThreshold>;

}

/**
 * 
 */
export class ReferralsApi extends runtime.BaseAPI implements ReferralsApiInterface {

    /**
     * Allows admins to create referral thresholds.
     */
    async createReferralRewardThresholdRaw(requestParameters: CreateReferralRewardThresholdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReferralRewardThreshold>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/referral-reward-threshold`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateReferralRewardThresholdBodyToJSON(requestParameters['createReferralRewardThresholdBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReferralRewardThresholdFromJSON(jsonValue));
    }

    /**
     * Allows admins to create referral thresholds.
     */
    async createReferralRewardThreshold(requestParameters: CreateReferralRewardThresholdRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReferralRewardThreshold> {
        const response = await this.createReferralRewardThresholdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * removes a referral for a given user
     */
    async deleteReferralsRemoveReferralRaw(requestParameters: DeleteReferralsRemoveReferralRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/referrals/remove-referral`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: RemoveReferralRequestBodyToJSON(requestParameters['removeReferralRequestBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * removes a referral for a given user
     */
    async deleteReferralsRemoveReferral(requestParameters: DeleteReferralsRemoveReferralRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteReferralsRemoveReferralRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getReferralLinkTextRaw(requestParameters: GetReferralLinkTextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReferralLinkText>> {
        const queryParameters: any = {};

        if (requestParameters['relationshipType'] != null) {
            queryParameters['relationshipType'] = requestParameters['relationshipType'];
        }

        if (requestParameters['referralCode'] != null) {
            queryParameters['referralCode'] = requestParameters['referralCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/referral-link-text`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReferralLinkTextFromJSON(jsonValue));
    }

    /**
     */
    async getReferralLinkText(requestParameters: GetReferralLinkTextRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReferralLinkText> {
        const response = await this.getReferralLinkTextRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getReferralRewardThresholdsRaw(requestParameters: GetReferralRewardThresholdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetReferralRewardThresholdsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['disabled'] != null) {
            queryParameters['disabled'] = requestParameters['disabled'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['numberOfAvailableOffsets'] != null) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters['numberOfAvailableOffsets'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/referral-reward-thresholds`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetReferralRewardThresholdsResponseFromJSON(jsonValue));
    }

    /**
     */
    async getReferralRewardThresholds(requestParameters: GetReferralRewardThresholdsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetReferralRewardThresholdsResponse> {
        const response = await this.getReferralRewardThresholdsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getReferralsRaw(requestParameters: GetReferralsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetReferralCodesResponse>> {
        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/referrals`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetReferralCodesResponseFromJSON(jsonValue));
    }

    /**
     */
    async getReferrals(requestParameters: GetReferralsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetReferralCodesResponse> {
        const response = await this.getReferralsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Public read of the active referral program. Returns the highest-reward, non-disabled, non-hidden, non-expired ReferralRewardThreshold as a display payload for the /account Refer-a-Friend section. Admin owns every string surfaced here verbatim.
     */
    async getReferralsActiveProgramRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ActiveReferralProgramResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/referrals/active-program`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ActiveReferralProgramResponseFromJSON(jsonValue));
    }

    /**
     * Public read of the active referral program. Returns the highest-reward, non-disabled, non-hidden, non-expired ReferralRewardThreshold as a display payload for the /account Refer-a-Friend section. Admin owns every string surfaced here verbatim.
     */
    async getReferralsActiveProgram(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ActiveReferralProgramResponse> {
        const response = await this.getReferralsActiveProgramRaw(initOverrides);
        return await response.value();
    }

    /**
     * generate all referrals data for exporting CSV in the admin portal
     */
    async getReferralsGenerateAllReferralsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenerateAllReferralsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/referrals/generate-all-referrals`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GenerateAllReferralsResponseFromJSON(jsonValue));
    }

    /**
     * generate all referrals data for exporting CSV in the admin portal
     */
    async getReferralsGenerateAllReferrals(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenerateAllReferralsResponse> {
        const response = await this.getReferralsGenerateAllReferralsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get a user\'s referred users
     */
    async getReferralsGetReferredUsersIdRaw(requestParameters: GetReferralsGetReferredUsersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReferredUsersResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getReferralsGetReferredUsersId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/referrals/get-referred-users/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReferredUsersResponseFromJSON(jsonValue));
    }

    /**
     * Get a user\'s referred users
     */
    async getReferralsGetReferredUsersId(requestParameters: GetReferralsGetReferredUsersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReferredUsersResponse> {
        const response = await this.getReferralsGetReferredUsersIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateReferralLinkTextRaw(requestParameters: UpdateReferralLinkTextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/referral-link-text`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ReferralLinkTextBodyToJSON(requestParameters['referralLinkTextBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateReferralLinkText(requestParameters: UpdateReferralLinkTextRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateReferralLinkTextRaw(requestParameters, initOverrides);
    }

    /**
     * Allows admins to update referral thresholds.
     */
    async updateReferralRewardThresholdIdRaw(requestParameters: UpdateReferralRewardThresholdIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReferralRewardThreshold>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateReferralRewardThresholdId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/referral-reward-threshold/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateReferralRewardThresholdBodyToJSON(requestParameters['createReferralRewardThresholdBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReferralRewardThresholdFromJSON(jsonValue));
    }

    /**
     * Allows admins to update referral thresholds.
     */
    async updateReferralRewardThresholdId(requestParameters: UpdateReferralRewardThresholdIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReferralRewardThreshold> {
        const response = await this.updateReferralRewardThresholdIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
